import * as React from 'react';
import slugify from 'slugify';
import styled from 'styled-components';
import { Icon } from '../ui';
import { variables } from '../utils';

interface Toggle {
  text: string;
  selected: boolean;
  inGroup?: boolean | string;
  onClick?: () => void;
}

const CheckToggle = styled.button.attrs({
  className: 'flex items-center justify-center ba br-100',
  'data-testid': 'toggle-button'
})<{ inGroup: boolean; selected: boolean }>`
  background: ${({ selected }) => selected && variables.blue};
  background: ${({ inGroup }) => inGroup && variables.moonGray};
  border-color: ${({ inGroup }) => (inGroup ? variables.moonGray : variables.blue)};
  height: 24px;
  width: 24px;
`;

const Toggle: React.FunctionComponent<Toggle> = ({ text, selected, inGroup, ...rest }) => (
  <div
    className="flex justify-between items-center f6 lh-copy bt b--light-gray pv2"
    data-testid={`${slugify(text)}-${selected ? 'selected' : 'not-selected'}`}
    data-selected={selected}
  >
    <span className="f6 navy truncate">{text}</span>

    <div className="flex items-center">
      {inGroup && <p className="f7 sans-serif tr moon-gray mr2 mv0">{inGroup}</p>}
      <CheckToggle inGroup={!!inGroup} selected={selected} {...rest}>
        {selected && !inGroup && <Icon name="check" color="white" size={14} />}
        {!selected && inGroup && <Icon name="check" color="white" size={14} />}
        {selected && inGroup && <Icon name="check" color="white" size={14} />}
      </CheckToggle>
    </div>
  </div>
);

export default Toggle;
